import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    effect,
    inject,
    signal,
} from '@angular/core';

import { IConstant } from '@frontend/oxygen/shared-utils';
import * as _ from 'underscore';

import { CmsService } from '../../../core/services/cms/cms.service';
import { ISystemConfig, SBreactionConfig } from '../../../core/services/cms/models';
import { PubSubService } from '../../../core/services/communication/pubsub/pubsub.service';
import { ReactionsService } from '../../../core/services/reactions/reactions.service';
import { UserService } from '../../../core/services/user/user.service';
import { IOutputModule } from '../../../featured/models/output-module.model';
import { WidgetVisibilityDirective } from '../../../widget-visibility/widget-visibility.directive';
import { GA_TRACKING } from '../../constants/channel.constant';
import { ISurfaceBetModule, SurfaceBetReactionResponse } from '../../models/surface-bet-module.model';

@Component({
    selector: 'surface-bets-carousel',
    templateUrl: './surface-bets-carousel.component.html',
    styleUrls: ['./surface-bets-carousel.component.scss'],
    standalone: false,
    hostDirectives: [WidgetVisibilityDirective],
})
export class SurfaceBetsCarouselComponent implements OnInit, OnChanges, OnDestroy {
    @Input() module: ISurfaceBetModule | IOutputModule;
    @Input() sportId: number;
    @Input() hubIndex: number;
    @Input() isEdp: boolean;
    @Input() isV2Design?: boolean;
    @Input() slideCount?: number;
    @Output() sBLoaded = new EventEmitter<string>();
    sbReactionConfig: SBreactionConfig;
    showReactions: boolean;
    reactionData: SurfaceBetReactionResponse;
    sportName: string;

    public slides = signal(0);

    public carouselName: string = _.uniqueId('surface_bet_carousel');

    surfaceBetsData: any;
    moduleCopy: any;
    GATrackingObj = {
        event: GA_TRACKING.event,
        GATracking: {
            eventAction: GA_TRACKING.eventAction,
            eventCategory: GA_TRACKING.surfaceBet.eventCategory,
            eventLabel: '',
        },
    };
    widgetVisibility = inject(WidgetVisibilityDirective);

    constructor(
        protected changeDetRef: ChangeDetectorRef,
        protected pubsub: PubSubService,
        protected cmsService: CmsService,
        protected reactionsService: ReactionsService,
        protected user: UserService,
    ) {
        effect(
            () => {
                if (this.slides() > 0) {
                    this.widgetVisibility.markReady();
                }
            },
            { allowSignalWrites: true },
        );
    }

    public get isOneCard(): boolean {
        return this.module && this.module.data && this.module.data.length === 1;
    }
    public set isOneCard(value: boolean) {}
    ngOnInit(): void {
        this.pubsub.subscribe(this.carouselName, this.pubsub.API.OUTCOME_UPDATED, () => {
            this.changeDetRef.detectChanges();
        });
        this.moduleCopy = [...this.module.data];
        this.surfaceBetsData = this.moduleCopy.slice(0, 3);
        this.slides.set(this.surfaceBetsData.length);
        this.moduleCopy.splice(0, 3);
        if (!this.user.status) {
            this.sBLoaded.emit('sbLoaded');
        }
        this.pubsub.subscribe(this.carouselName, [this.pubsub.API.SUCCESSFUL_LOGIN], () => {
            this.user.status && this.getReactions();
        });
    }
    getReactions(): void {
        this.cmsService.getSystemConfig().subscribe((config: ISystemConfig) => {
            this.sbReactionConfig = config['SurfaceBetReaction'];
            if (!this.isEdp && !this.hubIndex && this.sbReactionConfig?.enabled) {
                this.cmsService.getMenuItems().subscribe((menuItems) => {
                    const menuFound = menuItems.find((menu) => menu.categoryId !== null && menu.categoryId?.toString() === this.sportId.toString());
                    this.sportName = menuFound?.imageTitle as string;
                    menuFound && menuFound.isReactionsEnabled && this.getReactionAPI();
                });
            } else if (this.isEdp && this.sbReactionConfig?.showOnEdp && this.sbReactionConfig?.enabled) {
                this.getReactionAPI();
            } else if (this.hubIndex && this.sbReactionConfig?.showOnEventHub && this.sbReactionConfig?.enabled) {
                this.getReactionAPI();
            } else {
                this.showReactions = false;
                this.changeDetRef.detectChanges();
            }
        });
    }

    /**
     * triggers when sb reaction loaded
     */
    sbReactionsLoaded() {
        this.sBLoaded.emit('reactions');
    }

    getReactionAPI(): void {
        const body: IConstant[] = [];
        this.module.data.forEach((el) => {
            body.push({ selectionId: el.selectionId, surfaceBetId: el.objId });
        });
        this.reactionsService.getReactionsCount(this.user.custId, this.user.bppToken, body).subscribe((reactions: SurfaceBetReactionResponse) => {
            this.reactionData = reactions;
            this.showReactions = true;
            this.changeDetRef.detectChanges();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.module && this.module.data) {
            this.slides.set(this.module.data.filter((slide) => slide.markets && slide.markets.length).length);
            this.surfaceBetsData = this.module.data;
            this.user.status && this.getReactions();
            this.changeDetRef.detectChanges();
        }
    }

    ngOnDestroy(): void {
        this.pubsub.unsubscribe(this.carouselName);
    }

    fetchSurfaceBetsData(event: string): void {
        if (this.surfaceBetsData.length !== this.module.data.length && event === 'next') {
            const nextSet = this.moduleCopy.slice(0, 3);
            this.moduleCopy.splice(0, 3);
            nextSet.forEach((e: IConstant) => {
                this.surfaceBetsData.push(e);
            });
            this.slides.set(this.surfaceBetsData.length);
        }
    }
}
